export function isInParentTurfScope(
  parentTurf: { lft: number; rgt: number; id: number },
  turf: { lft: number; rgt: number; id: number }
) {
  return (
    parentTurf.id === turf.id ||
    (turf.lft > parentTurf.lft && turf.rgt < parentTurf.rgt)
  )
}
